import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  PlayCircleOutlined,
  MinusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons';

import { ETestStatus } from '@/shared/types';

export const TEST_STATUS_TO_TAG_SETTINGS = {
  [ETestStatus.NotStarted]: {
    text: 'Не приступил',
    color: 'gray',
    icon: <MinusOutlined />,
  },
  [ETestStatus.InProgress]: {
    text: 'В процессе',
    color: 'blue',
    icon: <PlayCircleOutlined />,
  },
  [ETestStatus.OnReview]: {
    text: 'На проверке',
    color: 'gold',
    icon: <ClockCircleOutlined />,
  },
  [ETestStatus.TestPassed]: {
    text: 'Тест сдан',
    color: 'green',
    icon: <CheckCircleOutlined />,
  },
  [ETestStatus.TestFailed]: {
    text: 'Тест не сдан',
    color: 'volcano',
    icon: <CloseCircleOutlined />,
  },
  [ETestStatus.WaitingForDocuments]: {
    text: 'Ожидание документов',
    color: 'cyan',
    icon: <ClockCircleOutlined />,
  },
  [ETestStatus.InReserve]: {
    text: 'Резерв',
    color: 'orange',
    icon: <TeamOutlined />,
  },
  [ETestStatus.Approved]: {
    text: 'Одобрено',
    color: 'green',
    icon: <CheckOutlined />,
  },
  [ETestStatus.Rejected]: {
    text: 'Отклонено',
    color: 'volcano',
    icon: <CloseOutlined />,
  },
};
